
      import API from "!../../../@jupyterlab/builder/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../@jupyterlab/builder/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../@jupyterlab/builder/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../@jupyterlab/builder/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../@jupyterlab/builder/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../@jupyterlab/builder/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../@jupyterlab/builder/node_modules/css-loader/dist/cjs.js!./xterm.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../@jupyterlab/builder/node_modules/css-loader/dist/cjs.js!./xterm.css";
       export default content && content.locals ? content.locals : undefined;
